import { gql } from '@apollo/client';

export const GET_TALENT_INVITE_LINKS_FOR_CAMPAIGN = gql`
  query GetTalentInviteLinksForCampaign(
    $input: GetTalentInviteLinksForCampaignInput!
  ) {
    getTalentInviteLinksForCampaign(input: $input) {
      id
      code
      type
      createdAt
    }
  }
`;

export const GET_TALENT_INVITE_LINKS = gql`
  query GetTalentInviteLinks($input: GetTalentInviteLinksInput!) {
    getTalentInviteLinks(input: $input) {
      id
      code
      type
      campaignId
      createdAt
    }
  }
`;
